<template>
	<div>
		<div v-if="relatorio_voo_trecho.length > 0">
			<table
				class="table table-bordered table-condensed table-siga"
				v-if="db._diario"
				v-for="(db, index) in relatorio_voo_trecho"
				:key="index"
			>
				<thead>
					<tr>
						<th colspan="7" style="background: #eee" class="text-center">
							{{ db._diario.numero_diario }} - {{ _traducao('global', 'diarioDeBordo').toUpperCase() }}
						</th>
					</tr>
					<tr>
						<th>{{ _traducao('global', 'acionamento') }}:</th>
						<th>{{ _traducao('global', 'decolagem') }}:</th>
						<th>{{ _traducao('global', 'pouso') }}:</th>
						<th>{{ _traducao('global', 'corte') }}:</th>
						<th>{{ _traducao('global', 'horimetroInicial') }}:</th>
						<th>{{ _traducao('global', 'horimetroFinal') }}:</th>
						<th>{{ _traducao('global', 'pousos') }}:</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td style="width: 14.2%">
							{{ db._diario.acionamento | dataTempo }}
						</td>
						<td style="width: 14.2%">
							{{ db._diario.decolagem | dataTempo }}
						</td>
						<td style="width: 14.2%">
							{{ db._diario.pouso | dataTempo }}
						</td>
						<td style="width: 14.2%">
							{{ db._diario.corte | dataTempo }}
						</td>
						<td style="width: 14.2%">
							{{ db._diario.horimetro_partida | horimetro }}
						</td>
						<td style="width: 14.2%">
							{{ db._diario.horimetro_corte | horimetro }}
						</td>
						<td style="width: 14.2%">
							{{ db._diario.pousos }}
						</td>
					</tr>
					<tr>
						<td>
							<strong>{{ _traducao('menuOrdemMissao', 'menuMissao') }}:</strong>
						</td>
						<td colspan="2">
							{{ db._diario.descricao_missao }}
						</td>
						<td>
							<strong>{{ _traducao('menuVoo', 'menuVtipoMissao') }}:</strong>
						</td>
						<td colspan="3">
							{{ db._diario.descricao_tipo_missao }}
						</td>
					</tr>
					<tr>
						<td>
							<strong>{{ _traducao('global', 'historico') }}:</strong>
						</td>
						<td colspan="6">
							{{ db._diario.observacao }}
						</td>
					</tr>
					<tr>
						<td>
							<strong>{{ _traducao('global', 'tripulacao') }}:</strong>
						</td>
						<td colspan="6">
							<div v-for="(trip, idxTrip) in db._diario.tripulacao" :key="idxTrip">
								<!-- <span v-if="db._diario.voo_instrucao == '0'">{{trip.funcao.toUpperCase()}}</span> -->
								<span>
									<span v-if="trip.funcao == 'Piloto em Comando'"> 1º PILOTO COMANDO </span>
									<span v-else-if="trip.funcao == 'Copiloto'">2º PILOTO EM COMANDO</span>
									<span v-else>
										{{ trip.funcao.toUpperCase() }}
									</span>
								</span>
								<i class="fa fa-fw fa-long-arrow-right" aria-hidden="true"></i>{{ trip.nome }}
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<table v-if="relatorio_voo_trecho.length > 0" class="table table-bordered table-condensed table-siga">
			<thead>
				<tr>
					<th colspan="7" style="background: #eee" class="text-center">
						{{ _traducao('global', 'totais').toUpperCase() }}
					</th>
				</tr>
				<tr>
					<th>
						{{ _traducao('global', 'diurno') }}
					</th>
					<th>
						{{ _traducao('global', 'noturno') }}
					</th>
					<th>IFR</th>
					<th>
						{{ _traducao('global', 'navegacao') }}
					</th>
					<th>
						{{ _traducao('global', 'instrucao') }}
					</th>
					<th>
						{{ _traducao('global', 'total') }}
					</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td style="width: 16.6666%">
						{{ diurno | horimetro }}
					</td>
					<td style="width: 16.6666%">
						{{ noturno | horimetro }}
					</td>
					<td style="width: 16.6666%">
						{{ ifr | horimetro }}
					</td>
					<td style="width: 16.6666%">
						{{ navegacao | horimetro }}
					</td>
					<td style="width: 16.6666%">
						{{ instrucao | horimetro }}
					</td>
					<td style="width: 16.6666%">
						{{ total | horimetro }}
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	data() {
		return {
			relatorio_voo_trecho: [],
			diurno: 0,
			noturno: 0,
			ifr: 0,
			navegacao: 0,
			instrucao: 0,
			total: 0,
			__print: false
		}
	},

	methods: {
		carrega(relatorio) {
			this.relatorio_voo_trecho = relatorio

			if (this.relatorio_voo_trecho.length > 0) {
				this.carregaDiarios(this.relatorio_voo_trecho)
			}
		},

		carregaDiarios(diarios) {
			diarios = diarios.map((t) => {
				t.carregado = false
				t._diario = null
				return t
			})

			bus.$emit('load-in', {text: this._traducao('global', 'carregandoDiarios')})

			for (var i in diarios) {
				this.carregaDiario(diarios[i].id, i)
			}
		},

		carregaDiario(idDiario, index) {
			this._carregaDiarioExterno(idDiario, 'cta-maranhao', (retorno) => {
				this.relatorio_voo_trecho[index]._diario = retorno.trecho._diario_de_bordo
				this.relatorio_voo_trecho[index].carregado = true

				this.diurno += Number(retorno.trecho._diario_de_bordo.vfr_diurno)
				this.noturno += Number(retorno.trecho._diario_de_bordo.vfr_noturno)
				this.ifr += Number(retorno.trecho._diario_de_bordo.ifr)
				this.navegacao += Number(retorno.trecho._diario_de_bordo.navegacao)
				this.instrucao += retorno.trecho._diario_de_bordo.voo_instrucao == '1' ? Number(this.diurno + this.noturno) : 0
				this.total += Number(retorno.trecho._diario_de_bordo.vfr_diurno) + Number(retorno.trecho._diario_de_bordo.vfr_noturno)

				var carregados = true
				this.relatorio_voo_trecho = this.relatorio_voo_trecho.map((item) => {
					if (item.carregado == false) {
						carregados = false
					}

					return item
				})

				if (carregados) {
					bus.$emit('load-out')
					if (this.__print) {
						this.__print = false
					}
				}
			})
		}
	}
}
</script>